import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const MenuIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M1 2.5h8v.615H1V2.5ZM9 4.961H1v.615h8v-.615ZM9 7.424H1v.615h8v-.615Z" />
        </SvgIcon>
    );
};
